/*
Author: Hoi Tak Leung
Email: hoi.leung@greedy.mx
Last Update: 26/09/2023
*/

import { Typography, Container, Box } from "@mui/material";

import "./LegalDocument.css";
import { textlanguages } from "../../../data/textOfThePage";
import { useLanguageContext } from "../../../context/languageContext";

export default function Privacy() {
  const { languageSelected } = useLanguageContext();
  return (
    <Container>
      <Typography variant="h3" className="document-header">
        {textlanguages[languageSelected].legal.privacy.title}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.privacy.introduction}
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.privacy.sections[0].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {
          textlanguages[languageSelected].legal.privacy.sections[0]
            .paragraphs[0]
        }
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {
          textlanguages[languageSelected].legal.privacy.sections[0]
            .paragraphs[1]
        }{" "}
        <span style={{ color: "#005587" }}>
          {
            textlanguages[languageSelected].legal.privacy.sections[0]
              .paragraphs[2]
          }
        </span>
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.privacy.sections[1].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.privacy.sections[1].description}
      </Typography>
      <Box ml="30px" mt="20px">
        <LineNumber
          number="i."
          text={
            textlanguages[languageSelected].legal.privacy.sections[1].list[0]
          }
        />
        <LineNumber
          number="ii."
          text={
            textlanguages[languageSelected].legal.privacy.sections[1].list[1]
          }
        />
        <LineNumber
          number="iii."
          text={
            textlanguages[languageSelected].legal.privacy.sections[1].list[2]
          }
        />
        <LineNumber
          number="iv."
          text={
            textlanguages[languageSelected].legal.privacy.sections[1].list[3]
          }
        />
        <LineNumber
          number="v."
          text={
            textlanguages[languageSelected].legal.privacy.sections[1].list[4]
          }
        />
        <LineNumber
          number="vi."
          text={
            textlanguages[languageSelected].legal.privacy.sections[1].list[5]
          }
        />
        <LineNumber
          number="vii."
          text={
            textlanguages[languageSelected].legal.privacy.sections[1].list[6]
          }
        />
        <LineNumber
          number="viii."
          text={
            textlanguages[languageSelected].legal.privacy.sections[1].list[7]
          }
        />
      </Box>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.privacy.sections[2].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.privacy.sections[2].description}
      </Typography>
      <Box ml="30px" mt="20px">
        <LineNumber
          number="i."
          text={
            textlanguages[languageSelected].legal.privacy.sections[2].list[0]
          }
        />
        <LineNumber
          number="ii."
          text={
            textlanguages[languageSelected].legal.privacy.sections[2].list[1]
          }
        />
      </Box>
      <Typography variant="h6" className="document-content" mt="20px">
        {textlanguages[languageSelected].legal.privacy.sections[2].note}
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.privacy.sections[3].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.privacy.sections[3].description}
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.privacy.sections[4].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.privacy.sections[4].description}
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.privacy.sections[5].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {
          textlanguages[languageSelected].legal.privacy.sections[5]
            .paragraphs[0]
        }
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {
          textlanguages[languageSelected].legal.privacy.sections[5]
            .paragraphs[1]
        }
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.privacy.sections[6].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.privacy.sections[6].description}
      </Typography>
      <Box ml="30px" mt="20px">
        <LineNumber
          number="i."
          text={
            textlanguages[languageSelected].legal.privacy.sections[6].list[0]
          }
        />
        <LineNumber
          number="ii."
          text={
            textlanguages[languageSelected].legal.privacy.sections[6].list[1]
          }
        />
        <LineNumber
          number="iii."
          text={
            textlanguages[languageSelected].legal.privacy.sections[6].list[2]
          }
        />
        <LineNumber
          number="iv."
          text={
            textlanguages[languageSelected].legal.privacy.sections[6].list[3]
          }
        />
      </Box>
      <Typography variant="h6" className="document-content" mt="20px">
        {textlanguages[languageSelected].legal.privacy.sections[6].note}
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.privacy.sections[7].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {
          textlanguages[languageSelected].legal.privacy.sections[7]
            .description[0]
        }{" "}
        <span style={{ color: "#005587" }}>
          {
            textlanguages[languageSelected].legal.privacy.sections[7]
              .description[1]
          }
        </span>
        {
          textlanguages[languageSelected].legal.privacy.sections[7]
            .description[2]
        }
      </Typography>
      <Box ml="30px" mt="20px">
        <LineNumber
          number="i."
          text={
            textlanguages[languageSelected].legal.privacy.sections[7].list[0]
          }
        />
        <LineNumber
          number="ii."
          text={
            textlanguages[languageSelected].legal.privacy.sections[7].list[1]
          }
        />
        <LineNumber
          number="iii."
          text={
            textlanguages[languageSelected].legal.privacy.sections[7].list[2]
          }
        />
        <LineNumber
          number="iv."
          text={
            textlanguages[languageSelected].legal.privacy.sections[7].list[3]
          }
        />
        <LineNumber
          number="v."
          text={
            textlanguages[languageSelected].legal.privacy.sections[7].list[4]
          }
        />
      </Box>
      <Typography variant="h6" className="document-content" mt="20px">
        {
          textlanguages[languageSelected].legal.privacy.sections[7]
            .paragraphs[0]
        }
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {
          textlanguages[languageSelected].legal.privacy.sections[7]
            .paragraphs[1]
        }
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.privacy.sections[8].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {
          textlanguages[languageSelected].legal.privacy.sections[8]
            .paragraphs[0]
        }
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {
          textlanguages[languageSelected].legal.privacy.sections[8]
            .paragraphs[1]
        }
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {
          textlanguages[languageSelected].legal.privacy.sections[8]
            .paragraphs[2]
        }{" "}
        <a
          href={
            textlanguages[languageSelected].legal.privacy.sections[8]
              .paragraphs[3]
          }
          style={{ color: "#005587" }}
        >
          {
            textlanguages[languageSelected].legal.privacy.sections[8]
              .paragraphs[3]
          }
        </a>
        {
          textlanguages[languageSelected].legal.privacy.sections[8]
            .paragraphs[4]
        }{" "}
        <a
          href={
            textlanguages[languageSelected].legal.privacy.sections[8]
              .paragraphs[5]
          }
          style={{ color: "#005587" }}
        >
          {
            textlanguages[languageSelected].legal.privacy.sections[8]
              .paragraphs[5]
          }
        </a>
        .
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.privacy.sections[9].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {
          textlanguages[languageSelected].legal.privacy.sections[9]
            .paragraphs[0]
        }{" "}
        <a href="https://greedy.mx/" style={{ color: "#005587" }}>
          https://greedy.mx/
        </a>
        .
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {
          textlanguages[languageSelected].legal.privacy.sections[9]
            .paragraphs[1]
        }
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {
          textlanguages[languageSelected].legal.privacy.sections[9]
            .paragraphs[2]
        }{" "}
        <span style={{ color: "#005587" }}>
          {
            textlanguages[languageSelected].legal.privacy.sections[9]
              .paragraphs[3]
          }
        </span>{" "}
        {
          textlanguages[languageSelected].legal.privacy.sections[9]
            .paragraphs[4]
        }
      </Typography>
      <Typography
        variant="h6"
        className="document-content"
        sx={{ mt: "30px", fontWeight: "bold", textAlign: "end" }}
      >
        {textlanguages[languageSelected].legal.privacy.sections[9].lastUpdate}
      </Typography>
    </Container>
  );
}

const LineNumber = ({ number, text }) => {
  return (
    <Box sx={{ display: "flex" }}>
      <Typography
        variant="h6"
        sx={{
          display: "flex",
          alignItems: "start",
          width: "40px",
          minWidth: "40px",
        }}
      >
        {number}
      </Typography>
      <Typography variant="h6" className="document-content">
        {text}
      </Typography>
    </Box>
  );
};
